import { inspectionStatusCopy, type InspectionRun } from "./inspectorView";

/** A label from an actual update, not an inferred tool or invented progress stage. */
export function inspectionStepSummary(text: string): string {
  const line =
    text
      .split("\n")
      .map((line) => line.trim())
      .find(Boolean) ?? "Progress update";
  return line
    .replace(/^#{1,6}\s+/, "")
    .replace(/^[-*]\s+/, "")
    .replace(/\*\*|__/g, "")
    .slice(0, 180);
}

/** Keep history scoped even if a response includes unrelated runs; never mutate cached data. */
export function findingRequestHistory(runs: readonly InspectionRun[], current: InspectionRun) {
  if (!current.review) return [];
  const candidates = new Map(
    runs
      .filter(
        (run) =>
          run.review?.findingId === current.review?.findingId &&
          run.review?.policyId === current.review?.policyId,
      )
      .map((run) => [run.threadId, run]),
  );
  candidates.set(current.threadId, current);
  return [...candidates.values()].sort(
    (a, b) =>
      Date.parse(b.startedAt) - Date.parse(a.startedAt) || a.threadId.localeCompare(b.threadId),
  );
}

export function inspectionOutcome(run: InspectionRun) {
  switch (run.status) {
    case "completed":
      return { title: "Review complete", detail: "Inspector’s response is ready for your review." };
    case "running":
      return {
        title: "Review in progress",
        detail: "Follow the updates as Inspector works through the request.",
      };
    case "queued":
      return {
        title: "Ready to begin",
        detail: "The request is queued. Updates will appear when Inspector starts.",
      };
    case "failed":
      return {
        title: "Inspector failed",
        detail: inspectionStatusCopy(run),
      };
    case "interrupted":
      return {
        title: "Review stopped",
        detail: "Progress is saved here. Return to the finding to continue the review.",
      };
  }
}
